import { successChildAccountsListReducer, loaderListener, failedChildAccountsListReducer } from '../Slice/childAccountsListSlice';
import Utils from '../../../utils';
import { buildQueryString } from '../../../utils/CommonFunction';

export const fetchChildAccountsListApiCall = (values, dispatch) => {

    const {
        pageNo,
        limit,
        searchKey,
        // ordering,
    } = values;

    let dataToSend = {
        page: pageNo,
        page_size: limit,
        search: searchKey,
        // sort_order: ordering,
    }

    // Define an array of keys to check for falsy values
    const keysToDelete = ['search_query'];

    // Iterate through the keys and delete them if they are falsy in dataToSend
    keysToDelete.forEach(key => {
        if (!dataToSend[key]) {
            delete dataToSend[key];
        }
    });

    dispatch(
        loaderListener({
            loading: true
        })
    );

    const result = buildQueryString(dataToSend);
    Utils.api.getApiCall(
        `${Utils.EndPoint.vendorEndpoints.childAccountsListApi}`,
        Object.keys(dataToSend).length == 0 ? '' : `?${result}`,
        (respData) => {
            const { data } = respData;
            dispatch(
                loaderListener({
                    loading: false
                })
            );

            dispatch(
                successChildAccountsListReducer({
                    data: data.data,
                    total: data.page.total_records,
                    loading: false
                })
            );
        },
        (error) => {
            Utils.showAlert(2, error.detail);
            dispatch(failedChildAccountsListReducer(error.detail));
        }
    );

}

export const verifyChildAccountsApiCall = (values, setSubmitting, refetch) => {
    const dataToSend = values;

    Utils.api.postApiCall(
        `${Utils.EndPoint.vendorEndpoints.verifyChildAccountsApi}`,
        dataToSend,
        (respData) => {
            const { data } = respData
            Utils.showAlert(1, 'Account verified, Please login.')
            setSubmitting(false);
            refetch();
        },
        (error) => {
            
            const { data } = error;
            Utils.showAlert(2, data.message);
            setSubmitting(false);
        }
    )
}